import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=5a96b17e&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=ts"
export * from "./StatCard.vue?vue&type=script&lang=ts"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=5a96b17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96b17e",
  null
  
)

export default component.exports